import type { MaybeRefOrGetter, Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { IGetTrackerTrafficSourceResponse } from '../types';
import {
  AFFILIATE_TRACKER_TRAFFIC_SOURCE_LIST_API_URL,
  AFFILIATE_TRACKER_TRAFFIC_SOURCE_LIST_QUERY,
  AFFILIATES_APPROVED_TRACKERS_LIST_PERMISSIONS,
} from '../constants';

export default function useAffiliateTrackerTrafficSourcesQuery(
  id: Ref<number>,
  enabled: MaybeRefOrGetter<boolean | undefined> = true,
): IContextQueryResult<IGetTrackerTrafficSourceResponse> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IGetTrackerTrafficSourceResponse>({
    queryKey: [AFFILIATE_TRACKER_TRAFFIC_SOURCE_LIST_QUERY, id],
    queryFn: ({ signal }) => fetchGet<IGetTrackerTrafficSourceResponse>(
      AFFILIATE_TRACKER_TRAFFIC_SOURCE_LIST_API_URL,
      {
        signal,
        permission: AFFILIATES_APPROVED_TRACKERS_LIST_PERMISSIONS.CHANGE_TRAFFIC_SOURCE,
        urlParams: {
          id: id.value,
        },
      },
    ),
    enabled,
  });
}
